import Http from '@/utils/http';
// import { AppResponse, IVCourseResult, IStudyToolResult, CanlendarLiveData, ExamResponse, type IResourcesCoverListItem } from '@/types';

// 学生项目列表(包括已过期的课程)
export const getStudentProjectsAll = () => Http.get('/ep-course/api/v1/front/student/projects-all');

// 学习周报
export const getG2WeekReports = (params: { courseId: number }) => Http.get('/student-learning/front/weekReport/weekList', params);

// 阶段报告
export const getGradationReports = (params: { courseId: number }) => Http.get('/student-learning/report/student/gradation/allList', params);

// 获取学员的考季学情报表
export const getExaminationSeasonReports = (params: { courseId: number }) => Http.post('/eds-sss-center/api/v1/gurarnteed-class/list', params);

// ep3学习周报
export const getEP3WeekReports = (courseId: number) => Http.get(`/ep-study/front/report/student/course/${courseId}/weeks`);

// 获取考季报告 科目课程数据
export const getSeasonSubjects = (projectId: number) => Http.get(`/ep-course/api/v1/front/report/project/${projectId}/subjects-all`);

// 获取对应课程下面的考绩 报告 
export const getCourseSeaonReport = (params: {projectId: number; courseId: number}) => Http.get(`/student-learning/front/project/season-report`, params)
